import React from 'react';
import {connect} from "react-redux";
import {addLike} from "../../actions/updateFirestoreData/recipesData/addLike";
import {red, blue} from '@material-ui/core/colors';
import {Menu, MenuItem, Fade, Grid, IconButton} from '@material-ui/core';
import ThumbsUpDownIcon from '@material-ui/icons/ThumbsUpDown';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ThumbDownAltIcon from '@material-ui/icons/ThumbDownAlt';


/**
 * This class is used to add a like or dislike for a recipe;
 * on click on ThumbsUpDownIcon, display a Fade menu, when you could click on add a like or dislike
 */
class LikeMenu extends React.Component {
    state = {
        anchorEl : null,
        open:false
    };

    handleClick = async (event) => {
        this.setState({anchorEl:event.currentTarget, open:true});
    };

    handleClose = () =>{
        this.setState({anchorEl:null, open:false});
    };
    positiveLike = async () => {
        this.handleClose();
        await this.props.addLike({recipeName: this.props.recipeName, userPseudo: this.props.auth ? this.props.auth.pseudo :"", value: 1});
    };
    negativeLike = async () => {
        this.handleClose();
        await this.props.addLike({recipeName: this.props.recipeName, userPseudo: this.props.auth ? this.props.auth.pseudo :"", value: -1});
    };

    render() {

        return (
            <Grid>
                <IconButton type='button'>
                    <ThumbsUpDownIcon aria-controls="fade-menu" aria-haspopup="true" onClick={this.handleClick}/>
                </IconButton>
                <Menu
                    id="fade-menu"
                    anchorEl={this.state.anchorEl}
                    keepMounted
                    open={this.state.open}
                    onClose={this.handleClose}
                    TransitionComponent={Fade}
                >
                    <MenuItem onClick={this.positiveLike}><ThumbUpIcon style={{ color: blue[300] }}/></MenuItem>
                    <MenuItem onClick={this.negativeLike}><ThumbDownAltIcon style={{ color: red[500] }}/></MenuItem>
                </Menu>
            </Grid>
        )
    };
}


const mapStateToProps = ({auth}) => {
    return {auth}
};


export default connect(
    mapStateToProps,
    {addLike}
)(LikeMenu)
